import { render, staticRenderFns } from "./personnelInfo.vue?vue&type=template&id=39cfd036"
import script from "./personnelInfo.vue?vue&type=script&lang=js"
export * from "./personnelInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports